import React, { forwardRef, useRef, useState, useImperativeHandle } from "react";
import { RCCHookToast, RCCRefModalProps, RCCServicesApi } from "react-common-components";
import Modal from "src/components/Modal";
import ModalSide from "src/components/Modal/styles";
import { useLoaderBackdrop } from "src/context/LoaderBackdrop/context";
import { useTranslation } from "src/context/Translations/context";
import { standardErrorMessages } from "src/utils/errors";
import groupBy from "src/utils/groupArrayByKey";
import { ActionType } from "../interface";
import History from "./History";
import { ICheckListItem, IHistory } from "./History/interface";

export interface IActionHistoryRef{
    openModalActionHistory: (id: number, titleAction: string, showOnlyWithAttachments: boolean, onCallback?: Function, disabled?: boolean) => void;
}

const ModalHistory: React.ForwardRefRenderFunction<IActionHistoryRef> = (_, ref) => {
	const { translate } = useTranslation();
	const { setLoading } = useLoaderBackdrop();
	const { addToast } = RCCHookToast();
    
	// Modal history
	const modalHistory = useRef<RCCRefModalProps>(null);
	const onCallbackHistory = useRef<Function | undefined>(undefined);
	const [history, setHistory] = useState<IHistory[]>([]);
	const [actionId, setActionId] = useState(0);
	const [actionType, setActionType] = useState<ActionType>();
	const [subtitle, setSubtitle] = useState<string | undefined>(undefined);
	const [onlyWithAttachments, setOnlyWithAttachments] = useState(false);
	const [isDisabled, setDisabled] = useState(false);
	const [autorityId, setAuthorityId] = useState(0);

	const openModalActionHistory = async (id: number, titleAction: string, showOnlyWithAttachments: boolean, onCallback?: Function, disabled?: boolean) => {
		try{
			setLoading(true);

			const {data} = await RCCServicesApi.getRequest({
				method: "Actions/SelectHistory",
				urlParameters: {
					id,
					showOnlyWithAttachments
				}
			});
			data.history = data.history.map((hist: IHistory) => {
				const groupByInb009Titulo = groupBy<ICheckListItem>(["inb009Titulo"]);
				const intbb009 = groupByInb009Titulo(hist.intbb016);
				return {
					...hist,
					intbb009
				};
			});
			setActionType(data.actionType);
			setHistory(data.history);
			setAuthorityId(data.inb001Efa005Id2);
			setOnlyWithAttachments(showOnlyWithAttachments);
			onCallbackHistory.current = onCallback;
			setLoading(false);
			setActionId(id);
			setDisabled(disabled || false);
			setSubtitle(titleAction);
			modalHistory.current?.openModal();
		}catch(err){
			setLoading(false);
			standardErrorMessages(err, translate("Erro ao buscar histórico"), addToast);
		}
	};

	useImperativeHandle(ref, () => ({
		openModalActionHistory
	}));

	return (
		<>
			<Modal 
				ref={modalHistory}
				header={{
					title: translate("Histórico"),
					subtitle: `${translate("Ação")}: ${subtitle}`,
					icon: {
						name: "history"
					}
				}}
				footer= {{
					showSaveButton: false,
					buttonLoadingText: translate("Carregando"),
					saveButtonText: translate("Salvar"),
					cancelButtonText: translate("Cancelar")
				}}
				onClose={() => {
					if(onCallbackHistory.current !== undefined)
						onCallbackHistory.current();
				}}
				withoutForm
				styleInline={ModalSide}
			>
				<History 
					data={history} 
					actionId={actionId} 
					actionType={actionType}
					actionName={subtitle ?? ""} 
					onlyWithAttachments={onlyWithAttachments} 
					disabled={isDisabled} authorityId={autorityId} 
				/>
			</Modal>
		</>
	);
};

export default forwardRef(ModalHistory);
